import { createFileRoute } from "@tanstack/react-router";
import { LoginLinkPage } from "~/pages/Login/LoginLink";

export const Route = createFileRoute("/_auth/login-link")({
  component: LoginLinkPage,
});
